import { environment } from './../../environment/environment';
export var text = {
  data() {
    return {
      defaultLanguage: environment.endpoint.defaultLanguage,
      translated: {
        applications: { en: 'Applications', fr: 'Applications', es: "Aplicaciones" },
        canvasPage: { en: 'Page', fr: 'Page', es: 'Página' },
        canvasLine: { en: 'Line', fr: 'Ligne', es: 'Línea' },
        canvasColumn: { en: 'Column', fr: 'Colonne', es: 'Columna' },
        canvasItem: { en: 'Item', fr: 'Element', es: 'Elemento' },
        dialogConfirmation: { en: 'CONFIRMATION', fr: 'CONFIRMATION', es: 'CONFIRMACIÓN' },
        dialogInformation: { en: 'INFORMATION', fr: 'INFORMATION', es: 'INFORMACIÓN' },
        dialogError: { en: 'ERROR', fr: 'ERREUR', es: 'ERROR' },
        dialogCancel: { en: 'CANCEL', fr: 'ANNULER', es: 'CANCELAR' },
        confirmDelete: { en: 'Confirm delete?', fr: 'Confirmation de la suppression?', es: '¿Confirma eliminación?' },
        querySearchText: { en: 'Search text', fr: 'Texte à rechercher', es: 'Texto a buscar' },
        queryTypeTitle: { en: 'Query', fr: 'Requête', es: 'Consulta' },
        formTypeTitle: { en: 'Form', fr: 'Forme', es: 'Formulario' },
        canvasTypeText: { en: 'Canvas', fr: 'Toile', es: 'Lienzo' },
        uploadText: { en: 'Upload', fr: 'Téléverser', es: 'Cargar' },
        downloadText: { en: 'Download', fr: 'Télécharger', es: 'Descargar' },
        exportText: { en: 'Export to', fr: 'Exporter vers', es: 'Exportar a' },
        importText: { en: 'Import from', fr: 'Importer depuis', es: 'Importar desde' },
        logText: { en: 'Log', fr: 'Log', es: 'Log' },
        requiredFieldText: { en: 'Required', fr: 'Obligatoire', es: 'Requerido' },
        invalidFieldText: { en: 'Invalid', fr: 'Invalide', es: 'Inválido' },
        passwordHelpText: { en: 'At least 8 caracters', fr: 'Minimum 8 caractères', es: 'Mínimo 8 caracteres' },
        successText: { en: 'Success', fr: 'Succès', es: 'Hecho' },
        errorText: { en: 'Error', fr: 'Erreur', es: 'Error' },
        confirmText: { en: 'Confirm', fr: 'Confirmer', es: 'Confirmar' },
        querySearch: { en: 'Search by text', fr: 'Rechercher par texte', es: 'Búsqueda por texto' },
        queryFilterField: { en: 'Add filter field', fr: 'Ajouter champ pour filtre', es: 'Agregar campo para filtro' },
        queryReload: { en: 'Reload', fr: 'Recharger', es: 'Recargar' },
        closeThis: { en: 'Close this window', fr: 'Fermer cette fenêtre', es: 'Cerrar esta ventana' },
        closeAll: { en: 'Close all', fr: 'Fermer tout', es: 'Cerrar todo' },
        switchLanguage: { en: 'Switch language to french', fr: 'Changer de langue en anglais', es: 'Cambiar lenguaje a español' },
        home: { en: 'Home', fr: 'Accueil', es: 'Inicio' },
        menu: { en: 'Menu', fr: 'Menu', es: 'Menú' },
        menuDisplay: { en: 'Display menu options', fr: 'Afficher les options du menu', es: 'Desplegar opciones de menú' },
        profile: { en: 'Profile', fr: 'Profil', es: 'Perfil' },
        logoff: { en: 'Logoff', fr: 'Déconnexion', es: 'Desconectarse' },
        largeText: { en: 'Large', fr: 'Longeur', es: 'Longitud' },
        confirmChangesText: { en: 'Save changes?', fr: 'Sauvegarder les modifications?', es: '¿Guardar los cambios?' },
        saveText: { en: 'Save', fr: 'Sauvegarder', es: 'Guardar' },
        dontSaveText: { en: "Don't Save", fr: 'Pas sauvegarder', es: 'No guardar' },
        cancelText: { en: 'Cancel', fr: 'Annuler', es: 'Cancelar' },
        dontText: { en: "Don't", fr: 'Pas', es: 'No' },
        totalRecordsText: { en: "Total of records", fr: "Nombre total d'enregistrements", es: 'Total de registros' },
        pageLimitText: { en: "Page Size", fr: "Taille Page", es: 'Tamaño de la página' },
        todayText: { en: "Today", fr: "Aujourd'hui", es: 'Hoy' },
        monthText: { en: 'Month', fr: 'Mois', es: 'Mes' },
        weekText: { en: 'Week', fr: 'Semaine', es: 'Semana' },
        dayText: { en: 'Day', fr: 'Jour', es: 'Día' },
        okText: { en: 'ok', fr: 'ok', es: 'ok' },
        alerts: { en: 'Alerts', fr: 'Alertes', es: 'Alertas' },
        clearText: { en: 'Clear', fr: 'Effacer', es: 'Limpiar' },
        signedText: { en: 'Signed', fr: 'Signé', es: 'Firmado' }
      },
      errors: {
        loadingError: { en: 'Error loading transaction', fr: 'Erreur de chargement de la transaction', es: 'Error cargando transacción' },
        processError: { en: 'Error processing transaction', fr: 'Erreur de traitement de la transaction', es: 'Error procesando transacción' },
        catalogError: { en: 'Error loading catalog', fr: 'Erreur de chargement de catalogue', es: 'Error cargando catálogo' },
        dictionaryLoadError: { en: 'Error loading dictionary', fr: 'Erreur de chargement de dictionnaire', es: 'Error cargando diccionario' },
        queryError: { en: 'Error loading query', fr: 'Erreur de chargement de requête', es: 'Error cargando consulta' },
        canvasError: { en: 'Error loading canvas', fr: 'Erreur de chargement de toile', es: 'Error cargando lienzo' },
        foreignKeyError: { en: "Doesn't exist", fr: "N'existe pas", es: 'No existe' },
        uploadingError: { en: 'Error uploading files', fr: 'Erreur de télécharger fichiers', es: 'Error en carga de archivos' },
        uploadFileError: { en: 'File uploading with errors', fr: 'Télécharger de fichier avec des erreurs', es: 'Carga de archivos con errores' },
        downloadFileError: { en: 'Error downloading file', fr: 'Erreur de télécharger fichier', es: 'Error descargando archivo' },
        dictionaryError: { en: 'Dictionary null', fr: 'Dictionnaire vide', es: 'Diccionario vacío' },
        queryFileError: { en: 'Error querying file for temporary url', fr: "Erreur lors de la requête du fichier pour l'URL temporaire", es: 'Error consultando archivo para url temporal' },
        queryExtendedDataError: { en: 'Error extended data for query', fr: 'Erreur des données étendues pour requête', es: 'Error en datos extendidos para consulta' },
        dynamicFilesError: { en: 'Error with dynamic files', fr: 'Erreur avec des fichiers dynamiques', es: 'Error con archivos dinámicos' },
      }
    }
  },
  methods: {
    translatedText(key) {
      const language = this.currentLanguage();
      const item = this.translated[key];
      const value = item[language] ? item[language] : '';
      return value;
    },
    errorMessage(key, complement) {
      const language = this.currentLanguage();
      const item = this.errors[key];
      const value = item[language] ? item[language] : '';
      const added = this.notBlank(complement) ? " " + complement : "";
      return value + added;
    },
    languages(generalExApplicationEx) {
      const okInput = generalExApplicationEx && !this.emptyObject(generalExApplicationEx);
      const lan = okInput ? generalExApplicationEx.generalEx.general.language : null;
      const sec = okInput ? generalExApplicationEx.generalEx.general.secLanguage : null;
      const items = [
        { id: lan ? lan : 'en' },
        { id: sec ? sec : 'fr' }
      ]
      return items;
    },
    currentLanguage(generalExApplicationEx) {
      let language = localStorage.getItem('language');
      if (!language) {
        language = this.defaultLanguage
          ? this.defaultLanguage
          : this.languages(generalExApplicationEx)[0].id;
      }
      return language;
    },
    currentLanguageEx(generalExApplicationEx) {
      return this.currentLanguage(generalExApplicationEx) + '-CA';
    },
    changeLanguage(generalExApplicationEx) {
      const current = this.currentLanguage(generalExApplicationEx);
      this.languages(generalExApplicationEx).forEach(language => {
        if (language.id != current) {
          localStorage.setItem('language', language.id);
        }
      })
      const newLan = this.currentLanguage(generalExApplicationEx);
      return newLan;
    },
    languageIndex(generalExApplicationEx, language) {
      let index = 0;
      this.languages(generalExApplicationEx).forEach((lg, ix) => {
        if (lg.id == language) {
          index = ix;
        }
      })
      return index;
    },
    translatedKey(generalExApplicationEx, language, key) {
      const index = this.languageIndex(generalExApplicationEx, language);
      const text1st = key;
      const text2nd = key + 'Lan';
      let result = text1st;
      if (index > 0 && text2nd) {
        result = text2nd;
      }
      return result;
    },
    translatedConfig(generalExApplicationEx, language, object, key) {
      let result = object[this.translatedKey(generalExApplicationEx, language, key)];
      if (!result) {
        result = object[key];
      }
      return result;
    },
    translatedItems(generalExApplicationEx, language, items, key) {
      let output = null;
      if (items) {
        output = [];
        const index = this.languageIndex(generalExApplicationEx, language);
        items.forEach(item => {
          const text1st = item[key];
          const text2nd = item[key + 'Lan'];
          let text = text1st;
          if (index > 0 && text2nd) {
            text = text2nd;
          }
          let outItem = item;
          outItem[key] = text;
          output.push(outItem);
        })
      }
      return output;
    },
    invertedLanguage(generalExApplicationEx) {
      const current = this.currentLanguage(generalExApplicationEx);
      let newLan = current;
      this.languages(generalExApplicationEx).forEach(language => {
        if (language.id != current) {
          newLan = language.id;
        }
      })
      return newLan;
    }
  }
}